import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
// import { Card, Button, Typography, Input, Container } from "@material-ui/core";
import Dragndroppage from "./Dragndroppage.js";

import Spinner from "../../sample/spinner";
import Chip from "@material-ui/core/Chip";
import Latex from "./Latex.js";

class MtfAssesment extends Component {
  constructor(props) {
    super(props);
    const matchthePairAssignmentlist = [];

    this.state = {
      contentType: props.contentType,
      contentId: props.contentId,
      matchthePairAssignmentlist,
      showComponent: false,
    };
  }

  componentDidUpdate(prevProps) {
    
   // console.log("this.s.contentId1  = " + this.state.contentId)
    if (
      prevProps.contentType !== this.props.contentType ||
      prevProps.contentId !== this.props.contentId
    ) {
      this.setState({
        contentType: this.props.contentType,
        contentId: this.props.contentId,
      });

      if (this.props.contentType === "Topiclevel") {
        //console.log("this.state.contentId  = " + this.state.contentId)
        this.getmatchthepairdata();
      } else {
        // this.getUnitMcq();
      }
    }
  }

  componentDidMount() {
    this.getmatchthepairdata();
  }

  async getmatchthepairdata() {
    let formData = new FormData();
    formData.append("topic", this.props.contentId);
    axios
      .post("LearnerAssignment/getMatchthePairAssignment", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
       
          this.setState({
            matchthePairAssignmentlist: res.data.matchthePairAssignmentlist,
            showComponent: false,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  render() {
    return (
      <div>
        {this.state.showComponent === true ? (
          <>
            <Spinner />
          </>
        ) : (
          ""
        )}
        <div class="row">
          <div className="col-lg-6">
            <Chip
              label="Match The Pair"
              variant="outlined"
              className="ft-size"
              color="primary"
            />
          </div>
        </div>
        <br />
        <div id="style-6" class="scrollmcq">
        {this.state.matchthePairAssignmentlist ? (
          <>
            {this.state.matchthePairAssignmentlist.map((item, indexitem) => (
              <>
                <div class="card p-3 mb-2">
                  <div class="row ">
                    <div class="col-md-9 col-lg-9 text-left">
                      <label for={item.assignmenttext}>
                        {" "}
                        Question &nbsp;
                        {indexitem + 1} ) &nbsp;
                        <Latex>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item.assignmenttext,
                          }}
                         /></Latex>
                      </label>{" "}
                    </div>
                    <div class="col-sm-2">
                      <Chip
                        label={"weightage :" + item.weightage}
                        className="ft-size"
                      />
                    </div>
                  </div>
                  <span className="pb-3"></span>
                  {item.question.map((itemn, indexitemn) => (
                    <>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="list-card1">
                            <ul className="list-q">
                              <li className=""> <Latex>{itemn.question}</Latex></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                    <span className="p-2">
                      <p className="note-arrange">Please Arrange the Below Option (Drag and Drop) to Match With Respective Questions</p>
                    </span>
                  <Dragndroppage
                    newshufflearray={item.answermap}
                    assignmentid={item.assignmentid}
                    assignmentOfferingid={item.assignmentOfferingid}
                    mtfQuetionlist={item.question}
                  />
                </div>
              </>
            ))}
          </>
        ) : (
          "NO Match the pair on this section!"
        )}
        </div>
      </div>
    );
  }
}

export default MtfAssesment;
